import React from 'react'

const Button = ({children, className, onClick, type="button", disabled, variant="primary", style}) => {

    const buttonClasses = {
        primary: 'bg-secondary linear-gradient-to-r from-secondary to-[#B8941F] text-black px-6 py-2 rounded-full font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-secondary/50 ease-in-out',
        secondary: 'bg-black text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-secondary/50 ease-in-out',
        outline: 'bg-transparent border border-secondary text-secondary',
        'outline-secondary': 'bg-transparent border border-secondary text-secondary',
        'outline-white': 'bg-transparent border border-white text-white',
        'outline-black': 'bg-transparent border border-black text-black',
        'outline-gray': 'bg-transparent border border-gray text-gray',
        'outline-transparent': 'bg-transparent text-secondary',
        'bg-transparent-secondary': 'bg-transparent text-secondary',
        'bg-custom': '',
    }

  return (
    <button
        className={`${buttonClasses[variant]} ${className} cursor-pointer`}
        style={style}
        onClick={onClick}
        type={type}
        disabled={disabled}

    >
        {children}
    </button>
  )
}

export default Button